export const getPageAccessUid = (state: any, id: String) => {
    console.log("state.user.accessCrud", state.user.accessCrud)
    const accessCrud = state.user.accessCrud.find((item: any) => item.uid === id);
    return accessCrud.page_access_uid
}